/**
 * GlobeMapContext - React context for unified globe/map state management.
 *
 * This context provides a renderer-agnostic API for controlling the globe/map.
 * It enables both 3D globe and 2D map renderers to share the same state.
 */

import { createContext } from 'react'
import type { GlobeMapContextValue } from '../types'

/**
 * Context for globe/map state and operations.
 *
 * Use the useGlobeMap() hook to consume this context.
 * The context must be provided by GlobeMapProvider.
 */
export const GlobeMapContext = createContext<GlobeMapContextValue | null>(null)

GlobeMapContext.displayName = 'GlobeMapContext'
